const SlideshowBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M2 2h20v10H2z" />
    <path d="M22 2v10H2V2h20m2-2H0v14h24V0z" fill="#333" />
    <path fill="#fff" d="M2 2h10v10H2z" />
    <circle cx="6" cy="6" r="2" fill="#333" />
    <path fill="#333" d="M0 18v6h6l-6-6zM24 18v6h-6l6-6z" />
  </svg>
);

export default SlideshowBlockIcon;
